<ion-app [ngClass]="[ 'theme-' + (colorTheme$ | async) ]">
  <ion-split-pane [when]="showMenu" contentId="main-content"
    [class.shrink]="(sidebarDisplay$ | async) === 'minimal'"
    [class.compact]="(sidebarDisplay$ | async) === 'compact'">
    <ion-menu contentId="main-content" type="overlay">

      <ion-content *ngIf="(sidebarDisplay$ | async) === 'minimal'; else expandedSidebar" class="minimal">
        <ion-list>
          <ion-menu-toggle [autoHide]="false">
            <ion-item [routerLink]="['/game', characterSlot, 'settings']"
                      [analyticsClick]="'Navigate:Character:Settings'">
              <app-game-icon slot="start" icon="settings" ngxTippy="Settings" [tippyProps]="{ placement: 'right' }"></app-game-icon>
            </ion-item>

            <ion-item [analyticsClick]="'Navigate:Character:MessageLog'">
              <app-game-icon slot="start" icon="messages" [ngxTippy]="messageHistory" [tippyProps]="{ placement: 'right', maxWidth: 500 }"></app-game-icon>
            </ion-item>

            <div class="sublist-divider"></div>

            <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'resources']" lines="none" detail="false" routerLinkActive="selected"
                      [analyticsClick]="'Navigate:Character:Resources'">
              <app-game-icon slot="start" icon="resources" ngxTippy="Resources" [tippyProps]="{ placement: 'right' }"></app-game-icon>
            </ion-item>


            <ng-container *ngIf="{ inventoryUnlocked: inventoryUnlocked$ | async } as data">
              <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'inventory']" lines="none" detail="false" routerLinkActive="selected"
                        [analyticsClick]="'Navigate:Character:Inventory'" [disabled]="!data.inventoryUnlocked">
                <app-game-icon slot="start" icon="inventory" ngxTippy="Inventory" [tippyProps]="{ placement: 'right' }"></app-game-icon>
              </ion-item>
            </ng-container>

            <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'equipment']" lines="none" detail="false" routerLinkActive="selected"
                      [analyticsClick]="'Navigate:Character:Equipment'">
              <app-game-icon slot="start" icon="equipment" ngxTippy="Equipment" [tippyProps]="{ placement: 'right' }"></app-game-icon>
            </ion-item>

            <div class="sublist-divider"></div>

            <ng-container *ngFor="let p of gatheringTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="smallTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>

            <div class="sublist-divider"></div>

            <ng-container *ngFor="let p of refiningTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="smallTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>

            <div class="sublist-divider"></div>

            <ng-container *ngFor="let p of peripheralTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="smallTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>

          </ion-menu-toggle>
        </ion-list>
      </ion-content>

      <ng-template #expandedSidebar>
        <ion-content>
          <ion-button class="settings" fill="clear" [routerLink]="['/game', characterSlot, 'settings']"
                      [analyticsClick]="'Navigate:Character:Settings'">
            <app-game-icon slot="icon-only" icon="settings" [inlineIconSize]="true"></app-game-icon>
          </ion-button>

          <ion-button class="messages" fill="clear"
                      [ngxTippy]="messageHistory" [tippyProps]="{ placement: 'right', maxWidth: 500 }"
                      [analyticsClick]="'Navigate:Character:MessageLog'">
            <app-game-icon slot="icon-only" icon="messages" [inlineIconSize]="true"></app-game-icon>
          </ion-button>

          <app-hero></app-hero>

          <ion-list>
            <ion-menu-toggle [autoHide]="false">
              <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'resources']" lines="none" detail="false" routerLinkActive="selected"
                        [analyticsClick]="'Navigate:Character:Resources'">
                <app-game-icon slot="start" icon="resources"></app-game-icon>
                <ion-label>Resources</ion-label>
              </ion-item>

              <ion-list-header>You</ion-list-header>

              <ng-container *ngIf="{ inventoryUnlocked: inventoryUnlocked$ | async } as data">
                <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'inventory']" lines="none" detail="false" routerLinkActive="selected"
                          [disabled]="!data.inventoryUnlocked"
                          [analyticsClick]="'Navigate:Character:Inventory'">
                  <app-game-icon slot="start" icon="inventory"></app-game-icon>

                  <ion-label *ngIf="!data.inventoryUnlocked" class="ion-text-wrap">
                    <span>Inventory</span>
                    <div>Discover an item</div>
                  </ion-label>

                  <ion-label *ngIf="data.inventoryUnlocked" class="ion-text-wrap">
                    Inventory
                  </ion-label>
                </ion-item>
              </ng-container>

              <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, 'equipment']" lines="none" detail="false" routerLinkActive="selected"
                        [analyticsClick]="'Navigate:Character:Equipment'">
                <app-game-icon slot="start" icon="equipment"></app-game-icon>
                <ion-label>Equipment</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-list-header>Gathering</ion-list-header>

            <ng-container *ngFor="let p of gatheringTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="bigTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>
          </ion-list>

          <ion-list>
            <ion-list-header>Refining</ion-list-header>

            <ng-container *ngFor="let p of refiningTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="bigTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>
          </ion-list>

          <ion-list>
            <ion-list-header>Peripheral</ion-list-header>

            <ng-container *ngFor="let p of peripheralTradeskills; let i = index">
              <ng-container *ngIf="{ isUnlocked: p.unlocked | async } as tsData">
                <ng-container [ngTemplateOutlet]="bigTradeskillItem" [ngTemplateOutletContext]="{ p: p, tsData: tsData }"></ng-container>
              </ng-container>
            </ng-container>
          </ion-list>
        </ion-content>
      </ng-template>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

</ion-app>

<ng-template #smallTradeskillItem let-p="p" let-tsData="tsData">
  <ion-item routerDirection="root" [routerLink]="['/game', characterSlot, p.url]" lines="none" detail="false" routerLinkActive="selected" [disabled]="!tsData.isUnlocked" [analyticsClick]="'Navigate:Peripheral:' + p.title">
    <app-game-icon slot="start" [icon]="p.icon" [ngxTippy]="p.title" [tippyProps]="{ placement: 'right' }"></app-game-icon>

    <ion-icon class="info-badge"
              slot="start"
              *ngIf="badge(p) | async as badgeData"
              [icon]="badgeData.icon"
              [color]="badgeData.color"></ion-icon>
  </ion-item>
</ng-template>

<ng-template #bigTradeskillItem let-p="p" let-tsData="tsData">
  <ion-menu-toggle [autoHide]="false">
    <ion-item routerDirection="root"
              [routerLink]="['/game', characterSlot, p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
              [disabled]="!tsData.isUnlocked"
              [analyticsClick]="'Navigate:Peripheral:' + p.title">

      <app-game-icon slot="start" [icon]="p.icon"></app-game-icon>

      <ion-badge class="worker-badge"
                 slot="start"
                 *ngIf="p.workerCount | async as workerCount"
                 color="secondary">
        <ion-icon name="people"></ion-icon>
        {{ workerCount }}
      </ion-badge>

      <ion-icon class="info-badge"
                *ngIf="badge(p) | async as badgeData"
                [icon]="badgeData.icon"
                [color]="badgeData.color"></ion-icon>

      <ion-label *ngIf="!tsData.isUnlocked" class="ion-text-wrap">
        <span>{{ p.title }}</span>
        <div>{{ p.requirements }}</div>
      </ion-label>

      <ion-label *ngIf="tsData.isUnlocked">
        <span>{{ p.title }} Lv.{{ p.level | async }}</span>
        <div class="notify-area" *ngIf="{
          timer: timer(p) | async,
          notify: notify(p) | async
        } as displayData">
          <p *ngIf="displayData.notify?.message">
            <span>{{ displayData.notify?.message }}</span>
          </p>

          <p *ngIf="!displayData.notify?.message && p.timer">
            <app-countdown [duration]="displayData.timer || 0"></app-countdown>
          </p>
        </div>
      </ion-label>
    </ion-item>
  </ion-menu-toggle>
</ng-template>

<ng-template #messageHistory>
  <div>
    <strong>Message History</strong>
  </div>

  <br>

  <div *ngIf="notifyService.allMessages.length === 0">
    <em>No messages.</em>
  </div>

  <div *ngFor="let message of notifyService.allMessages">
    {{ message }}
  </div>
</ng-template>
